import FuneralInvitationPage from "@/views/funeral/FuneralInvitationPage.vue";
import FuneralInvitationEditPage from "@/views/funeral/FuneralInvitationEditPage.vue";

const funeralRoutes = [
  {
    path: "/funeral",
    name: "FuneralInvitationPage",
    component: FuneralInvitationPage,
  },
    {
      path: "/funeral/edit/:funeralInvitationSeq",
      name: "FuneralInvitationEditPage",
      components: {
        default: FuneralInvitationEditPage
      },
      props: {
        default: true
      }
    }
]

export default funeralRoutes;